import React, { useState } from 'react'
import moment from 'moment'
import {
  Form,
  Avatar,
  Table,
  Modal,
  Row,
  Card,
  Upload,
  Radio,
  Col,
  Button
} from 'antd'
import { HERO_TYPE_MESSAGE } from '../../../../utils/constants'
import Lightbox from 'react-image-lightbox'
import '../../../../../node_modules/react-image-lightbox/style.css'
import styled from 'styled-components'
import axios from 'axios'

const BillForm = (props) => {
  const { visible, onCancel, formData, formDataBill } = props
  const [current, setCurrent] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const map =
    'https://www.google.com/maps/search/?api=1&query=' +
    formDataBill.latitude +
    ',' +
    formDataBill.longitude

  const handleClickImage = (e, image) => {
    e && e.preventDefault()
    setCurrent(image)
  }

  const handleCloseModal = (e) => {
    e && e.preventDefault()
    setCurrent('')
  }

  const handleDelete = () => {
    handleCancelTransfer(formDataBill)
    setIsModalOpen(false)
  }

  const handleCancelTransfer = async (bill) => {
    try {
      const token = localStorage.getItem('user-token')

      const formData = new URLSearchParams()
      formData.append('billId', bill.billId)

      await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/recycle/admin-reject/${bill.billId}`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )

      onCancel(true)
    } catch (error) {
      console.error(error.response.data || error.message)
    }
  }

  const columns = [
    {
      title: 'รูปภาพ',
      dataIndex: 'image',
      key: 'image',
      render: (text) => (
        <div>
          {text ? (
            <img
              src={text}
              width={60}
              height={60}
              style={{ marginRight: 10, objectFit: 'cover' }}
              alt="image"
              onClick={(e) => handleClickImage(e, text)}
            />
          ) : (
            '-'
          )}
          {current && (
            <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
          )}
        </div>
      )
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (name) => name + ' ชิ้น'
    },
    {
      title: 'วัสดุ',
      dataIndex: 'materialName',
      key: 'materialName',
      render: (name, row) => (
        <Row type="flex" gutter={8}>
          <Col>
            <Avatar src={row.materialImage} size={48} />
          </Col>
          <Col>
            <span style={{ lineHeight: '45px' }}>{name}</span>
          </Col>
        </Row>
      )
    },
    {
      title: 'ปริมาณการส่ง',
      dataIndex: 'sendAmountKg',
      key: 'sendAmountKg',
      align: 'right',
      render: (name, row) => name + ' ' + row.unit
    },
    {
      title: 'ปริมาณการรับ',
      dataIndex: 'receiveAmountKg',
      key: 'receiveAmountKg',
      align: 'right',
      render: (name, row) => name + ' ' + row.unit
    }
  ]

  return (
    <Modal
      width={800}
      visible={visible}
      title="รายละเอียด"
      footer={null}
      onCancel={onCancel}>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>Reference Code : </h4>
        </Col>
        <Col>
          <div>{formData.referenceCode}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>Bill ID : </h4>
        </Col>
        <Col>
          <div>{formDataBill.billId}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>วันที่ทำการส่งต่อ : </h4>
        </Col>
        <Col>
          <div>{moment(formDataBill.createdDate).format('DD/MM/YYYY')}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ส่งต่อให้ : </h4>
        </Col>
        <Col>
          <div>{formDataBill.heroName}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>จุดส่งวัสดุ : </h4>
        </Col>
        <Col>
          <div>{formDataBill.heroLocationName}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ที่อยู่ : </h4>
        </Col>
        <Col>
          <div>{formDataBill.heroLocationAddress}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ประเภทฮีโร่ : </h4>
        </Col>
        <Col>
          <div>{HERO_TYPE_MESSAGE[formDataBill.heroType]}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>สถานะ : </h4>
        </Col>
        <Col>
          <div>{formDataBill.status}</div>
        </Col>
        <Col>
          <CancelText onClick={() => setIsModalOpen(true)}>
            ยกเลิกการส่งต่อ
          </CancelText>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>Detail : </h4>
        </Col>
        <Col>
          <div>{formDataBill.comment}</div>
        </Col>
      </Row>
      <Row>
        <Card type="inner" title="รายการส่งต่อ">
          <Table
            dataSource={formDataBill.billItemList}
            columns={columns}
            pagination={false}
          />
        </Card>
      </Row>
      <Row type="flex" gutter={8}>
        <br></br>
      </Row>
      {formDataBill.activity && (
        <Row>
          <Card type="inner" title="กิจกรรมที่เข้าร่วม">
            <Row>
              <Col>
                <div>
                  {formDataBill.activity.image ? (
                    <img
                      src={formDataBill.activity.image}
                      width={170}
                      height={170}
                      style={{ marginRight: 10, objectFit: 'cover' }}
                      alt="activity"
                    />
                  ) : (
                    <div></div>
                  )}
                </div>
              </Col>
            </Row>
            <Row type="flex" gutter={8}>
              <br></br>
            </Row>
            <Row type="flex" gutter={8}>
              <Col>
                <h4>สนับสนุนโดย : </h4>
              </Col>
              <Col>
                <div>
                  <Avatar src={formDataBill.activity.brandLogo} size={24} />
                </div>
              </Col>
            </Row>
            <Row type="flex" gutter={8}>
              <h4>{formDataBill.activity.activityName}</h4>
            </Row>
            <Row type="flex" gutter={8}>
              <div>{formDataBill.activity.activityDetail}</div>
            </Row>
          </Card>
        </Row>
      )}
      <Row type="flex" gutter={8}>
        <br></br>
      </Row>
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button onClick={() => onCancel()}>ปิด</Button>
        </Col>
      </Row>
      <DeleteConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleDelete}
      />
    </Modal>
  )
}

const WrappedBillForm = Form.create({
  name: 'BillForm'
})(BillForm)
export default WrappedBillForm

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null

  return (
    <Overlay>
      <ModalContainer>
        <Title>ยกเลิกการส่งต่อ</Title>
        <ButtonGroup>
          <Button type="danger" onClick={onClose}>
            ยกเลิก
          </Button>
          <Button type="primary" onClick={onConfirm}>
            ยืนยัน
          </Button>
        </ButtonGroup>
      </ModalContainer>
    </Overlay>
  )
}

const CancelText = styled.span`
  color: #f3928e;
  font-size: 12px;
  cursor: pointer;
  margin-left: 10px;
  text-decoration: underline;
`

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
`

const ModalContainer = styled.div`
  background: white;
  padding: 24px;
  border-radius: 10px;
  width: 360px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
`

const Title = styled.div`
  margin-bottom: 20px;
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
`
